<template>
    <div id="produst-details">

        <div class="container">        
            <div class="row pt-5 pb-5">
                <div class="login-window d-flex">
                    <div class="slider reasonbg p-3">

                        <h2 class="text-center pb-3"><span>{{$t('5 reasons')}}</span> {{$t('to buy from us')}}</h2>
                        <ul class="row">
                            <li class="col-md-6 text-center">
                                <i class="reason-icon reason-1"></i>
                                <p>{{ $t('We are 100 % Finnish company, we employ people in Finland, we pay taxes in Finland.') }}</p>
                            </li>
                            <li class="col-md-6 text-center">
                                <i class="reason-icon reason-4"></i>
                                <p>{{ $t('We have large amount of service partners which cover all Finland, over 1000 free fitting times daily.') }}</p>
                            </li>
                            <li class="col-md-6 text-center">
                                <i class="reason-icon reason-2"></i>
                                <p>{{ $t('Low prices, own big stock and wide range of tyres, part payment, many different payment methods.') }}</p>
                            </li>
                            <li class="col-md-6 text-center">
                                <i class="reason-icon reason-3"></i>
                                <p>{{ $t('Fast delivery 24h, good service, Chat open.') }}</p>                                
                            </li>
                            <li class="col-md-12 text-center">
                                <i class="reason-icon reason-5"></i>
                                <p>{{ $t('Purchasing tyres from Finland you help reduce CO2 emission, we sale Ecological Tyres also.') }}</p>
                            </li>
                        </ul>

                    </div>


                    <div class="login-form">
                        
                        

                        <h1 class="mb-3">{{ $t('Become a Partner') }}</h1>

                        

                        
                        <b-overlay :show="loading" rounded="sm">

                            <form class="w-100" @submit.stop.prevent="handleSubmit">

                                <div v-if="isShow" class="col-12">

                            <bootstrap-alert 
                                :variant="responseResult.variant" 
                                :msg="responseResult.message" 
                                :errorMsg="responseResult.errmsg" 
                            />
                        </div>

                                <div class="form-group">
                                    <input type="text" 
                                        class="form-control input-field" 
                                        id="name" 
                                        v-model="form.name" 
                                        :placeholder="$t('Name')"
                                        name="name"
                                        required="required"
                                        />
                                </div>


                                <div class="form-group">
                                    
                                    <b-form-select 
                                        v-model="form.request_from"                                     
                                        id="request_from" 
                                        name="request_from" 
                                        required="required"
                                        class="form-control input-field selectcustom" >
                                            <option value="" disabled selected>{{ $t('Who Am I') }}</option>
                                            <option value="Tyre shop">{{ $t('Tyre shop') }}</option>
                                            <option value="Garage">{{ $t('Garage') }}</option>
                                            <option value="Car service point">{{ $t('Car service point') }}</option>
                                            <option value="Wholesaler">{{ $t('Wholesaler') }}</option>
                                            <option value="Web shop">{{ $t('Web shop') }}</option>
                                            <option value="Other">{{ $t('Other') }}</option>
                                    </b-form-select>

                                </div>

                                <div class="form-group">
                                    <div class="d-flex">
                                        
                                        <vue-country-code
                                            @onSelect="onSelect"
                                            :preferredCountries="['fi', 'vn', 'us', 'gb']"
                                            :disabledFetchingCountry="false"
                                            v-bind="bindProps"
                                            v-model="form.country_code"
                                            class="country-select"
                                            >
                                        </vue-country-code>

                                        <input 
                                        type="number" 
                                        class="form-control input-field" 
                                        id="mobile_number" 
                                        v-model="form.contact_number" 
                                        name="mobile_number" 
                                        autocomplete="off"
                                        :placeholder="$t('Mobile number')"
                                        required="required" />
                                    </div>
                                </div>
                                
                                <div class="form-group">
                                    <input 
                                        type="email" 
                                        class="form-control input-field" 
                                        id="email" 
                                        v-model="form.email" 
                                        autocomplete="off"
                                        name="email" 
                                        :placeholder="$t('Email')"
                                        required="required" />
                                </div>

                                <div class="form-group">
                                    <input type="text" 
                                        class="form-control input-field" 
                                        id="location" 
                                        v-model="form.location" 
                                        :placeholder="$t('Address')"
                                        name="location"
                                        required="required"
                                        />
                                </div>
                                
                                <div class="form-group">
                                    <textarea  
                                        class="form-control input-field" 
                                        id="Comment" 
                                        v-model="form.comment" 
                                        :placeholder="$t('Comment')"
                                        name="Comment"
                                        required="required"
                                        />
                                </div>

                                <captcha :form="form" ref="captchObj"></captcha>

                                <b-button  type="submit"
                                class="btn btn-primary d-block w-100 login-button bg-black">{{ $t('Become a Partner') }} </b-button>

                            </form>
                        </b-overlay>

                    </div>
                </div>
            </div>
        </div>
            
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import VueCountryCode from "vue-country-code";
import Vue from "vue";
Vue.use(VueCountryCode);
import  ApiService  from '../services/api.service'

import { BOverlay } from 'bootstrap-vue'
import Captcha from '../components/Captcha'
Vue.component('b-overlay', BOverlay)

export default {
    name: "become-a-partner",
    metaInfo() {
        return {
            title: 'Become A Partner',
            meta: [
                { charset: 'utf-8' },
                { name: 'title', content:  'Become A Partner'},
                { name: 'description', content: 'This is become a partner page'},
                { name: 'keywords', content:  'Become A Partner'},
                { name: 'robots', content: 'index,follow'},
            ],
            link: [
                {rel: 'canonical', href: process.env.VUE_APP_BASE_URL + 'become-a-partner'}
            ]
        }
    },
    components: {
        'captcha' : Captcha
    },
    data() {
        return {
            form: {
                name: "",
                request_from: "",
                contact_number: "",
                email: "",
                location: "",
                comment: "",
                country_code: '358',
            },
            isShow: false,
            responseResult: {
                message: '',
                variant: '',
                errmsg: []
            }, 
            loading: false,
            bindProps: {
                defaultCountry: "FI"
            },
        };
    },
    computed: {
        ...mapGetters('resetpassword', ['canvas']),
        ...mapGetters('app', ['currentLang'])
    },
    watch: { 
       
    },
    created() {
        if(this.isShow) {
            // var self = this;
            setTimeout(function(){ 

                // self.setIsShow(false)

                this.isShow = false;
                this.responseResult.message = "";
                this.responseResult.variant = "";
                this.responseResult.errmsg = [];

                
            }, 3000);
        }
    },
    methods: {
        handleSubmit() {

            var setflag = true;

            if(setflag) {

                this.form.contact_number = this.form.contact_number;

                this.loading = true;
                ApiService.post('/partner-request/create', this.form)
                .then(response => {
                    this.$refs.captchObj.refreshCaptcha()
                   
                    this.isShow = true;
                    this.responseResult.message = response.data;
                    this.responseResult.variant = 'success';
                    this.loading = false;
                    var self = this;
                     self.form.name= "";
                        self.form.request_from= "";
                        self.form.contact_number= "";
                        self.form.email= "";
                        self.form.location= "";
                        self.form.comment= "";
                        self.form.code = "";
                    setTimeout(function(){ 
                        self.responseResult.message = "";
                        self.responseResult.variant = "";
                        self.responseResult.errmsg = [];
                        self.isShow = false;
                    }, 10000);
                })
                .catch(error => {
                    this.loading = false;                    
                    this.isShow = true;
                    this.responseResult.message = "";
                    this.responseResult.variant = 'danger';
                    this.responseResult.errmsg = (error.response.data.errors) ? error.response.data.errors : error.response.data;
                });
            }
        },
        onSelect({name, iso2, dialCode}) {
            this.form.country_code = dialCode;
            
        },
    }
};
</script>